import { ref } from '@vue/composition-api'

export function useTemporaryLock(timeout = 10) {
  const isLocked = ref(false)
  const timer = ref<number | null>(null)

  function lock() {
    isLocked.value = true
    setTimeout(() => (isLocked.value = false), timeout)
  }

  function unlock() {
    isLocked.value = false
    timer.value && clearTimeout(timer.value)
  }

  return {
    lock,
    unlock,
    isLocked
  }
}
